// (c) chaehongee. Confidential and proprietary.

import type { ReactElement } from 'react'
import { memo } from 'react'
import type { MarqueeRect } from './useMarqueeSelection'

interface MarqueeOverlayProps {
    marqueeRect: MarqueeRect | null
}

export const MarqueeOverlay = memo(function MarqueeOverlay({
    marqueeRect,
}: MarqueeOverlayProps): ReactElement | null {
    if (!marqueeRect) return null

    const left = Math.min(marqueeRect.startX, marqueeRect.endX)
    const top = Math.min(marqueeRect.startY, marqueeRect.endY)
    const width = Math.abs(marqueeRect.endX - marqueeRect.startX)
    const height = Math.abs(marqueeRect.endY - marqueeRect.startY)

    return (
        <div
            style={{
                position: 'absolute',
                left,
                top,
                width,
                height,
                border: '1.5px dashed var(--color-accent)',
                background: 'color-mix(in srgb, var(--color-accent) 10%, transparent)',
                pointerEvents: 'none',
                zIndex: 5,
                borderRadius: 2,
            }}
        />
    )
})
